import React from 'react';

import NewCallIcon from 'common/components/icons/NewCallIcon';
import NewEmailIcon from 'common/components/icons/NewEmailIcon';
import NewSmsIcon from 'common/components/icons/NewSmsIcon';
import RatorEventIcon from 'common/components/icons/RatorEventIcon';
import ThreeSixtyIcon from 'common/components/icons/ThreeSixtyIcon';
import {WarningIcon} from '@phonectas/unifon-ui-kit';
import CommentsIcon from 'common/components/icons/CommentsIcon';
import NewInvoiceIcon from 'common/components/icons/NewInvoiceIcon';
import ZendeskIcon from 'common/components/icons/ZendeskIcon';

const getIconByType = (type: string): React.ReactElement => {
	switch (type) {
	case 'BN_CALL_LOG':
		return <NewCallIcon unifonColor/>;
	case 'email':
		return <NewEmailIcon />;
	case 'THREESIXTY_OUTGOING_SMS':
		return <NewSmsIcon />;
	case 'rator':
		return <RatorEventIcon />;
	case 'ERATE_SYSTEM_SMS':
		return <RatorEventIcon />;
	case 'ERATE_CALL_LOG':
		return <RatorEventIcon />;
	case 'THREESIXTY_NEW_CUSTOMER_RESP':
		return <ThreeSixtyIcon editSize="26"/>;
	case 'THREESIXTY_NEW_SAF_VALUE':
		return <ThreeSixtyIcon editSize="26"/>;
	case 'THREESIXTY_COMMENT':
		return <CommentsIcon $commentslength="..."/>;
	case 'THREESIXTY_OUTGOING_TRUSTPILOT':
		return <ThreeSixtyIcon editSize="26"/>;
	case 'THREESIXTY_INCIDENT_LOG':
		return <ThreeSixtyIcon editSize="26"/>;
	case 'VISMA_INVOICE':
		return <NewInvoiceIcon />;
	case 'ZENDESK_UPSELL':
		return <ZendeskIcon />;
	default:
		return <WarningIcon />;
	}
}

export default getIconByType;
